import Vue from 'vue'
import {
    encrypt,
    decrypt
} from "../../utils/utils";
import $cookies from 'vue-cookies'
export default {
    namespaced: true,
    state: {
        sessionid: $cookies.get("id") ? decrypt($cookies.get("id")) : '',
        hrid: $cookies.get("id") ? decrypt($cookies.get("id")) : '1',
        password: '',
        emailverified:$cookies.get("emailverified") ? decrypt($cookies.get("emailverified")) : '0',
        displayname: '',
        language: localStorage.getItem("language") ? decrypt(localStorage.getItem("language")) : 'EN',
        siteid: $cookies.get("siteId") ? decrypt($cookies.get("siteId")) : '',
        isforget: $cookies.get("isforget") ? $cookies.get("isforget") : '0',
        isfirst: $cookies.get("isfirst") ? $cookies.get("isfirst") : '0',
        headName: '',
        pelogo: '',
        description: '',
        logoUrl: require('../../assets/img/noprofile.png'),
        fileUserImgBase64: require('../../assets/img/noprofile.png'),
    },
    mutations: {
        setSessionid(state, sessionid) {
            state.sessionid = sessionid;
            $cookies.set("id", encrypt(sessionid));
        },
        setHrid(state, hrid) {
            state.hrid = hrid;
            $cookies.set("id", encrypt(hrid));
        },
        setPassword(state, password) {
            state.password = password;
        },
        setEmailverified(state, emailverified) {
            state.emailverified = emailverified;
            $cookies.set("emailverified", encrypt(emailverified ? '1' : '0'));
        },
        setIsSupplier(state,issupplier){
            state.issupplier = issupplier;
            $cookies.set("issupplier", issupplier);
        },
        setDisplayname(state, displayname) {
            state.displayname = displayname;
        },
        setLanguage(state, language) {
            state.language = language;
            localStorage.setItem("language", encrypt(language))
        },
        setSiteId(state, siteid) {
            state.siteid = siteid;
            $cookies.set("siteId", encrypt(siteid));
        },
        setHeadName(state, headName) {
            state.headName = headName;
        },
        setPeLogo(state, peLogo) {
            state.peLogo = peLogo;
        },
        setDescription(state, description) {
            state.description = description;
        },
        setFileUserImgBase64(state, fileUserImgBase64) {
            state.fileUserImgBase64 = fileUserImgBase64;
        },
        setUrlStatus(state,urlStatus){
            state.urlStatus = urlStatus;
            $cookies.set("urlstatus",urlStatus);
        },
        setUrlStatus2(state,urlStatus){
            state.urlStatus = urlStatus;
            $cookies.set("urlstatus2",urlStatus);
        },
        setIsForget(state,isForget){
            state.isforget = isForget;
            $cookies.set("isforget",isForget);
        },
        setIsFirstLogin(state,isFirst){
            state.isfirst = isFirst;
            $cookies.set("isfirst",isFirst);
        },
        removeUser(state) {
            localStorage.clear();
            sessionStorage.clear();
            Object.keys(state).forEach(k => k != 'logoUrl' ? Vue.set(state, k, '') : '');
            $cookies.remove("id");
            $cookies.remove("siteId");
            $cookies.remove("emailverified");
            $cookies.remove("urlstatus");
            $cookies.remove("issupplier");
            $cookies.remove("isforget");
            $cookies.remove("isfirst");
        },
        removeUrlstatus(state){
            $cookies.remove("urlstatus");
            $cookies.remove("urlstatus2");
        }
    },
    actions: {
        removeUser(context) {
            context.commit('removeUser');
        }
    },
    getters: {
        sessionid: state => state.sessionid,
        hrid: state => state.hrid,
        password: state => state.password,
        emailverified: state => state.emailverified,
        displayname: state => state.displayname,
        language: state => state.language,
        siteid: state => state.siteid,
        headName: state => state.headName,
        description: state => state.description,
        pelogo: state => state.pelogo,
        logoUrl: state => state.logoUrl,
        fileUserImgBase64: state => state.fileUserImgBase64,
        urlStatus: state =>state.urlStatus,
        urlStatus2: state =>state.urlStatus2,
        supplier: state =>state.supplier,
        isforget: state =>state.isforget,
        isfirst: state =>state.isfirst,
    }
}